import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import Item from './Item.jsx';

var ItemsPanel = createReactClass({
  propTypes: {
    mediaBrowserType: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    previewURL: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.string,
    onDeleteItem: PropTypes.func,
    onItemClick: PropTypes.func,
    onItemMove: PropTypes.func,
    bulkDeleteMode: PropTypes.bool,
    onBulkSelectItem: PropTypes.func,
  },

  getDefaultProps: function() {
    return {
      mediaBrowserType: 'files',
      name: '',
      previewURL: '',
      type: '',
      size: '',
      onDeleteItem: function() {},
      onItemClick: function() {},
    };
  },

  isImage: function(type) {
    if (type === 'image/jpeg' || type === 'image/png' || type === 'image/gif') {
      return true;
    }
    return false;
  },

  render: function() {
    // prejdeme itemy a vykreslime ich
    var itemsHtml = [];
    if (this.props.dir !== null && this.props.dir.length !== 0) {
      itemsHtml.push(
        <Item
          key="parent directory"
          name=".."
          id={this.props.dir[this.props.dir.length - 1]}
          onItemMove={this.props.onItemMove}
          onItemClick={this.props.onItemClick}
          previewURL=""
          size={0}
          type="parent"
          isDirectory={true}
        />,
      );
    }

    for (var i = 0; i < this.props.items.length; i++) {
      var item = this.props.items[i];
      if (
        item.type !== '' &&
        this.props.mediaBrowserType === 'images' &&
        this.isImage(item.type) === false
      ) {
      } else {
        var key = item.isDirectory ? item.id : item.uri;
        itemsHtml.push(
          <Item
            multipleSelect={this.props.multipleSelect}
            bulkDeleteMode={this.props.bulkDeleteMode}
            onBulkSelectItem={this.props.onBulkSelectItem}
            selectedForBulkDelete={item.selectedForBulkDelete}
            onDeleteItem={this.props.onDeleteItem}
            key={key}
            uri={item.uri}
            name={item.name}
            id={item.id}
            dir={item.dir}
            selected={item.selected}
            onItemClick={this.props.onItemClick}
            isDirectory={item.isDirectory}
            previewURL={item.previewURL}
            size={item.size}
            type={item.type}
            created={item.created}
            onItemMove={this.props.onItemMove}
            draggable="true"
            onDragEnter={this.props.onDragEnter}
            onDragLeave={this.props.onDragLeave}
          />,
        );
      }
    }

    return <div className="content-holder content-block">{itemsHtml}</div>;
  },
});

export default ItemsPanel;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/ItemsPanel.jsx